import { IOffer } from '../types';
import { IOfferForAnalytic } from './tracking/types';

/* Бэк в offerDescription отдаёт короткое имя программы («Семейная»),
   в разметке аналитики нужно полное — «Семейная ипотека» */
const OFFER_DESCRIPTION_FOR_ANALYTICS: Record<string, string> = {
  Семейная: 'Семейная ипотека',
};

export const mapOfferForAnalytics = (offer: IOffer): IOfferForAnalytic => ({
  name: offer.offerName,
  description: OFFER_DESCRIPTION_FOR_ANALYTICS[offer.offerDescription] ?? offer.offerDescription,
  psk: offer.psk ? `${offer.psk.from} - ${offer.psk.to}` : null,
  payment: offer.monthlyPayment,
  rate: offer.rate,
  type: offer.type,
});

export const mapOffersListForAnalytics = (offers: IOffer[]): IOfferForAnalytic[] => offers.map(mapOfferForAnalytics);
